module.exports = __webpack_public_path__ + "img/user.653f93c.jpg";